import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-radar-bericht',
  templateUrl: './radar-bericht.component.html',
  styleUrls: ['./radar-bericht.component.css']
})
export class RadarBerichtComponent {

}
